<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">
        {{ $t("Screening Schedule") }}
      </div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="cinemaDropdownOptions"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cinema_name"
                track-by="cinema_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
             
            </div>
          </div>
          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("Report ") }} {{ $tc("Type", 1) }}</label
              >
              <multiselect
                :options="typeArray"
                v-model="typeObj"
                :searchable="true"
                label="type_name"
                track-by="type_id"
                placeholder="Select Report Type"
                @input="onselectType($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("showdate") }}
                </label>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <input
                placeholder="."
                type="integer"
                v-model="refreshTime"
                name="employeeid"
                @blur="refreshValue"
                id="employeeid"
              />
              <!-- required|alpha_num -->
              <label>{{ $t("Refresh (in mins)") }}</label>
            </div>
          </div>
          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <div class="row">
              <div class="ml-3">
                <b-form-checkbox
                  switch
                  v-model="openShowOnly"
                  value="Y"
                  unchecked-value="N"
                  name="check-button"
                ></b-form-checkbox>
              </div>
              <div class="ml-3">
                <label>Open Show Only</label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-1 align-self-center mb-3">
            <button
              class="btn-blue w-100"
              @click.prevent="getReportData('N', 'N')"
            >
              {{ $t("fetch") }}
            </button>
          </div>
          <div
            class="align-self-center ml-3 pl-4 mb-3 d-flex justify-content-end align-items-center"
          >
            <a
              target="_blank"
              @click="excelDownload((isExcel = 'Y'))"
              title="Download as Excel"
              download
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/excel.svg"
                height="25"
                width="25"
              />
            </a>
            <a
              target="_blank"
              @click="getReportData('N', 'Y')"
              title="Download as Pdf"
              download
              v-if="checkClientName"
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/pdf-icon.svg"
                height="25"
                width="25"
              />
            </a>
          </div>
        </div>
      </div>
      <div
        style="overflow-x: scroll; width: auto !important"
        ref="exportable_table"
      >
        <table style="font-size: 11px" class="swc-report-table" border="1">
          <thead style="font-size: 10px" class="bg-lightgrey font-weight-bold">
            <template v-if="typeObj.type_id == 'screenwise'">
              <th style="font-size: 10px">Screen</th>
              <th style="font-size: 10px">Film</th>
            </template>
            <template v-else>
              <th style="font-size: 10px">Film</th>
              <th style="font-size: 10px">Screen</th>
            </template>

            <!-- <th>Session Id</th> -->
            <th style="font-size: 11px">Show</th>
            <th style="font-size: 11px">Starts</th>
            <!-- <th style="font-size: 11px;">Interval</th> -->
            <th style="font-size: 11px">Ends</th>
            <th style="font-size: 11px">BO</th>
            <th style="font-size: 11px">Prepaid</th>
            <th style="font-size: 11px">Total</th>
            <th style="font-size: 11px">Booked</th>
            <!-- <th style="font-size: 11px">In-Progress</th> -->
            <th style="font-size: 11px">Entered</th>
            <!-- <th style="font-size: 11px;">RS-H</th> -->
            <th style="font-size: 11px">Available</th>
            <th style="font-size: 11px">Occu%</th>
            <!-- <th style="font-size: 11px">ATP</th> -->
            <th style="font-size: 11px">Capacity</th>
            <!-- <th style="font-size: 11px">Gross</th> -->
            <th style="font-size: 11px">Rate Card</th>
            <!-- <th  class="w-5" style="font-size: 11px;">MTicket</th>
            <th class="w-5"  style="font-size: 11px;">MEnter</th>
            <th  class="w-5" style="font-size: 11px;">Unprinted</th> -->
          </thead>
          <tbody
            v-if="screenRecords.length > 0"
            v-for="(screenArr, screenDataIndex) in screenRecords"
            :key="screenDataIndex"
          >
            <tr :key="screenDataIndex + 'screenData'">
              <td class="text-left" :rowspan="screenArr.film_array.length + 1">
                {{ screenArr.screen_name }}
              </td>
            </tr>
            <tr
              v-for="(filmData, filmDataIndex) in screenArr.film_array"
              :key="filmDataIndex + 'filmData' + screenDataIndex"
            >
              <td class="text-left">
                {{
                  typeObj.type_id == "screenwise"
                    ? filmData.movie_name
                    : filmData.screen_name
                }}
              </td>
              <!-- <td class="text-left">
                {{ filmData.ss_id }}
              </td> -->
              <td class="text-right">
                {{ filmData.Show }}
              </td>
              <td class="text-left">
                {{
                  checkEpixCinema()
                    ? moment(filmData.ss_start_show_time, "HH:mm").format(
                        "hh:mm A"
                      )
                    : filmData.ss_start_show_time
                }}
              </td>
              <!-- <td class="text-left">{{ filmData.interval_time_in_mins }}</td> -->
              <td class="text-left">
                {{
                  checkEpixCinema()
                    ? moment(filmData.ss_end_show_time, "HH:mm").format(
                        "hh:mm A"
                      )
                    : filmData.ss_end_show_time
                }}
              </td>

              <td class="text-right" style="font-weight: bold">
                {{ filmData.boxOfficeSold }}
              </td>
              <td class="text-right" style="font-weight: bold">
                {{ filmData.onlineSold }}
              </td>
              <td class="text-right" style="font-weight: bold">
                {{ filmData.ticketSold }}
              </td>
              <td class="text-right" style="font-weight: bold">
                {{ filmData.UnpaidBooked }}
              </td>
              <td class="text-right">{{ filmData.ScannedTickets }}</td>
              <!-- <td class="text-left">-</td> -->
              <td class="text-right">
                {{
                  filmData.seatCount -
                  filmData.ticketSold -
                  filmData.UnpaidBooked
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat((filmData.ticketSold / filmData.seatCount) * 100)
                }}%
              </td>
              <!-- <td class="text-right">
                {{ currFormat(filmData.gross_amount / filmData.ticketSold) }}
              </td> -->
              <td class="text-right">
                {{ filmData.seatCount }}
              </td>
              <!-- <td class="text-right">
                {{ filmData.gross_amount }}
              </td> -->
              <td
                class="text-right"
                v-b-popover.hover.right="{
                  title: `<div class='fs-14'> Rate Card</div>`,
                  customClass: `my-popover-class`,
                  content: getRateCardHtml(filmData.rate_card_pricing),
                  html: true,
                }"
              >
                <div style="text-overflow: ellipsis">
                  {{
                    filmData.rate_card_pricing
                      ? filmData.rate_card_pricing.split(" / ").join(", ")
                          .length > 50
                        ? filmData.rate_card_pricing
                            .split(" / ")
                            .join(", ")
                            .substr(0, 30) + ".."
                        : filmData.rate_card_pricing.split(" / ").join(", ")
                      : "-"
                  }}
                </div>
              </td>

              <!-- <td class="text-right w-auto">0</td>
              <td class="text-right w-auto">0</td>
              <td class="text-right w-auto">0</td> -->
            </tr>
            <tr
              :key="screenDataIndex + 'grandTotal'"
              class="bg-lightgrey font-weight-bold"
              style="font-size: 12px"
            >
              <td style="font-size: 11px" class="text-left" colspan="5">
                Total
              </td>
              <td style="font-size: 11px" class="text-right">
                {{ screenArr.grandTotalObj.boxOfficeSold }}
              </td>
              <td style="font-size: 11px" class="text-right">
                {{ screenArr.grandTotalObj.onlineSold }}
              </td>
              <td style="font-size: 11px" class="text-right">
                {{ screenArr.grandTotalObj.ticketSold }}
              </td>
              <td style="font-size: 11px" class="text-right">
                {{ screenArr.grandTotalObj.UnpaidBooked }}
              </td>
              <td style="font-size: 11px" class="text-right">{{ screenArr.grandTotalObj.ScannedTickets }}</td>
              <!-- <td style="font-size: 11px" class="text-left">-</td> -->
              <td style="font-size: 11px" class="text-right">
                {{
                  screenArr.grandTotalObj.seatCount -
                  screenArr.grandTotalObj.ticketSold -
                  screenArr.grandTotalObj.UnpaidBooked
                }}
              </td>
              <td style="font-size: 11px" class="text-right">
                {{
                  currFormat(
                    (screenArr.grandTotalObj.ticketSold /
                      screenArr.grandTotalObj.seatCount) *
                      100
                  )
                }}%
              </td>
              <!-- <td style="font-size: 11px" class="text-right">
                {{
                  currFormat(
                    screenArr.grandTotalObj.gross_amount /
                      screenArr.grandTotalObj.ticketSold
                  )
                }}
              </td> -->
              <td style="font-size: 11px" class="text-right">
                {{ screenArr.grandTotalObj.seatCount }}
              </td>
              <!-- <td style="font-size: 11px" class="text-right">
                {{ currFormat(screenArr.grandTotalObj.gross_amount) }}
              </td> -->
              <td style="font-size: 11px" class="text-right">-</td>
              <!-- <td style="font-size: 11px" class="text-right">0</td>
              <td style="font-size: 11px" class="text-right">0</td>
              <td style="font-size: 11px" class="text-right">0</td> -->
            </tr>
          </tbody>
          <tbody v-if="screenRecords.length > 0">
            <tr class="bg-lightgrey font-weight-bold">
              <td class="text-left" colspan="20"></td>
            </tr>
            <tr style="font-size: 12px" class="bg-lightgrey font-weight-bold">
              <td class="text-left" style="font-size: 11px" colspan="2">
                Grand Total
              </td>
              <td class="text-right" style="font-size: 11px">
                {{ TotalCount }}
              </td>
              <td class="text-right" colspan="2"></td>
              <td class="text-right" style="font-size: 11px">
                {{ grandTotalObj.boxOfficeSold }}
              </td>
              <td class="text-right" style="font-size: 11px">
                {{ grandTotalObj.onlineSold }}
              </td>
              <td class="text-right" style="font-size: 11px">
                {{ grandTotalObj.ticketSold }}
              </td>
              <td class="text-right" style="font-size: 11px">
                {{ grandTotalObj.UnpaidBooked }}
              </td>
              <td class="text-right" style="font-size: 11px">{{ grandTotalObj.ScannedTickets }}</td>
              <!-- <td class="text-left" style="font-size: 11px">-</td> -->
              <td class="text-right" style="font-size: 11px">
                {{
                  grandTotalObj.seatCount -
                  grandTotalObj.ticketSold -
                  grandTotalObj.UnpaidBooked
                }}
              </td>
              <td class="text-right" style="font-size: 11px">
                {{
                  currFormat(
                    (grandTotalObj.ticketSold / grandTotalObj.seatCount) * 100
                  )
                }}%
              </td>
              <!-- <td class="text-right" style="font-size: 11px">
                {{
                  currFormat(
                    grandTotalObj.gross_amount / grandTotalObj.ticketSold
                  )
                }}
              </td> -->
              <td class="text-right" style="font-size: 11px">
                {{ grandTotalObj.seatCount }}
              </td>
              <!-- <td class="text-right" style="font-size: 11px">
                {{ currFormat(grandTotalObj.gross_amount) }}
              </td> -->
              <td class="text-right" style="font-size: 11px"></td>
              <!-- <td class="text-right" style="font-size: 11px">0</td>
              <td class="text-right" style="font-size: 11px">0</td>
              <td class="text-right w-5" style="font-size: 11px">0</td> -->
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="20">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import ScheduleService from "@/services/scheduleService";
import xlsx from "json-as-xlsx";
import { CLIENT_NAME } from "@/helper/Role";

import * as XLSX from "xlsx";

export default {
  components: {
    NoRecords,
    // VueHtml2pdf
  },
  data() {
    return {
      TotalCount: 0,
      BASEURL,
      isRoleID: false,
      submitted: false,
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
      fromDate: new Date(),
      toDate: new Date(),
      screenRecords: [],
      excelFilePath: "",
      grandTotal: {},
      openShowOnly: "Y",
      disabledDates: {
        from: "",
      },
      typeArray: [
        {
          type_id: "screenwise",
          type_name: "Screen Wise",
        },
        {
          type_id: "filmwise",
          type_name: "Film Wise",
        },
      ],
      typeObj: {
        type_id: "screenwise",
        type_name: "Screen Wise",
      },
      refreshTime: 5,
      grandTotalObj: {
        seatCount: 0,
        ticketSold: 0,
        UnpaidBooked: 0,
        gross_amount: 0,
        onlineSold: 0,
        boxOfficeSold: 0,
        ScannedTickets: 0
      },
    };
  },
  beforeDestroy() {
    this.clearIntervalTime();
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
    this.fromDate = new Date();
  },

  computed: {
    checkClientName() {
      console.log(this.CLIENT_SETUP_NAME);
      return CLIENT_NAME.STAR == this.CLIENT_SETUP_NAME;
    },
     cinemaDropdownOptions() {
                  const urlCinemaId = this.$route && this.$route.query && this.$route.query.cinema_id;
                  if (urlCinemaId && this.dropDown.cinemas && this.dropDown.cinemas.length > 0) {
                    const found = this.dropDown.cinemas.find(c => String(c.cinema_id) === String(urlCinemaId));
                    return found ? [found] : [];
                  }
                  return this.dropDown.cinemas;
                },
  },
  watch: {
    // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
    //   if (CinemaObj) {
    //     this.onSelectCinema(CinemaObj);
    //   }
    // },
     '$route.query.cinema_id': {
      handler(newVal) {
        if (newVal && this.dropDown.cinemas && this.dropDown.cinemas.length > 0) {
          const found = this.dropDown.cinemas.find(c => String(c.cinema_id) === String(newVal));
          if (found) {
            this.onSelectCinema(found);
            this.getReportData();
          }
        }
      },
      immediate: true
    },
    excelFilePath(value) {
      this.excelFilePath = value;
    },
    fromDate: function (value) {
      this.disabledDates.from = new Date(
        moment(this.fromDate).format("YYYY"),
        parseFloat(moment(this.fromDate).format("MM")),
        1
      );
      this.toDate = moment(this.toDate).isAfter(value, "months")
        ? moment(this.fromDate).endOf("month").format("YYYY-MM-DD")
        : this.toDate;
    },
    timerStart: "",
    counterStart: false,
  },
  mounted() {},
  methods: {
    getRateCardHtml(data) {
      let content = ``;
      if (data) {
        data.split(" / ").map((z) => {
          content += `<div>${z}</div>`;
        });
      }
      return content;
    },
    moment,
    checkEpixCinema() {
      return CLIENT_NAME.EPIX == this.$store.getters.CLIENT_SETUP_NAME;
    },
    convertTo12HourFormat(time) {
      let [hours, minutes] = time.split(":");

      let meridiem = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;

      minutes = minutes < 10 ? "0" + minutes : minutes;

      return hours + ":" + minutes + " " + meridiem;
    },
    excelDownload() {
      let temp_data = [...this.screenRecords];

      let temp_arr = [];
      temp_data.map((x) => {
        x.film_array.map((y) => {
          let obj = {
            ...x,
            ...y,
          };
          temp_arr.push(obj);
        });
      });

      let reportData = [
        {
          value:
            this.typeObj.type_id == "screenwise" ? "screen_name" : "movie_name",
          label: this.typeObj.type_id == "screenwise" ? "Screen" : "Film",
        },
        {
          value:
            this.typeObj.type_id == "screenwise" ? "movie_name" : "screen_name",
          label: this.typeObj.type_id == "screenwise" ? "Film" : "Screen",
        },
        {
          value: (row) => row.Show,
          label: "Show",
        },
        {
          value: "ss_start_show_time",
          label: "Starts",
        },

        {
          value: "ss_end_show_time",
          label: "End",
        },
        {
          value: (row) =>
            row.boxOfficeSold ? +parseFloat(row.boxOfficeSold) : 0,
          label: "BO",
        },
        {
          value: (row) => (row.onlineSold ? +parseFloat(row.onlineSold) : 0),
          label: "Prepaid",
        },

        {
          value: (row) => (row.ticketSold ? +parseFloat(row.ticketSold) : 0),
          label: "Total",
        },
        {
          value: (row) =>
            row.UnpaidBooked ? +parseFloat(row.UnpaidBooked) : 0,
          label: "Booked",
        },
        {
          value: (row) => "-",
          label: "In-Progress",
        },

        {
          value: (row) => row.seatCount - row.ticketSold - row.UnpaidBooked,
          label: "Available",
        },
        {
          value: (row) =>
            row.ticketSold && row.seatCount
              ? +parseFloat((row.ticketSold * 100) / row.seatCount).toFixed(3)
              : 0,
          label: "Occu%",
        },
        {
          value: (row) =>
            row.gross_amount && row.ticketSold
              ? +parseFloat(row.gross_amount / row.ticketSold).toFixed(3)
              : 0,
          label: "ATP",
        },
        {
          value: (row) => +parseFloat(row.seatCount),
          label: "Capacity",
        },
        {
          value: (row) =>
            row.gross_amount ? +parseFloat(row.gross_amount).toFixed(3) : 0,
          label: "Gross",
        },
        {
          value: (row) =>
            row.rate_card_pricing
              ? row.rate_card_pricing.split(" / ").join(", ")
              : "-",
          label: "Rate Card",
        },
      ];

      // let arraynew = currentStock;

      let data = [
        {
          sheet:
            this.typeObj.type_id == "screenwise"
              ? "Screen Wise Schedule Report"
              : "Film Wise Schedule Report",
          columns: reportData,
          content: temp_arr,
        },
      ];
      let cinemaName = this.dropDown.selectedCinemaName || " ";
      var today = new Date();
      var date =
        String(today.getDate()).padStart(2, "0") +
        "-" +
        String(today.getMonth() + 1).padStart(2, "0") +
        "-" +
        today.getFullYear();
      var time =
        String(today.getHours()).padStart(2, "0") +
        ":" +
        String(today.getMinutes()).padStart(2, "0") +
        ":" +
        String(today.getSeconds()).padStart(2, "0");

      var dateTime = date + "_AT_" + time;
      let settings = {
        fileName:
          this.typeObj.type_id == "screenwise"
            ? `ScreenWise_Scheduling_Report_${cinemaName}_${moment(
                this.fromDate
              ).format("YYYY-MM-DD")}_on${dateTime}`
            : `Filmwise_Scheduling_Report_${cinemaName}_${moment(
                this.fromDate
              ).format("YYYY-MM-DD")}_on${dateTime}`,
        // ${new Date().getTime()}
      };
      xlsx(data, settings);
    },
    calculateGrandTOtal() {
      this.grandTotalObj = {
        seatCount: 0,
        ticketSold: 0,
        UnpaidBooked: 0,
        gross_amount: 0,
        onlineSold: 0,
        boxOfficeSold: 0,
        ScannedTickets: 0,
      };
      if (this.screenRecords.length) {
        this.screenRecords.map((z) => {
          Object.keys(this.grandTotalObj).map((kk) => {
            this.grandTotalObj[kk] += z.grandTotalObj[kk] || 0;
          });
        });
      }
    },
    startInterval() {
      if (!this.counterStart) {
        this.counterStart = true;
        this.timerStart = setInterval(() => {
          this.getReportData();
        }, this.refreshTime * 60 * 1000);
      }
    },
    clearIntervalTime() {
      console.log("CLear Interval");
      if (this.timerStart) {
        clearInterval(this.timerStart);
        this.timerStart = "";
        this.counterStart = false;
      }
    },
    refreshValue() {
      if (this.refreshTime < 5) {
        this.$toasted.show("Cannot Set to Less than 5 min");
        this.refreshTime = 5;
      }
      this.clearIntervalTime();
      setTimeout((z) => {
        this.startInterval();
      }, 2000);
    },
    onselectType() {
      this.screenRecords = [];
    },
    getCinemaList: function () {
      MasterService.getCinemaList()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
            const urlCinemaId = this.$route && this.$route.query && this.$route.query.cinema_id;
            if (urlCinemaId) {
              const found = data.Records.find(c => String(c.cinema_id) === String(urlCinemaId));
              if (found) {
                this.onSelectCinema(found);
                this.getReportData();
                return;
              }
            }
            const defaultCinema = data.Records.find(c => c.cinema_id == 1);
            if (defaultCinema) {
              this.onSelectCinema(defaultCinema);
              this.getReportData();
            } else if (data.Records.length == 1) {
              this.onSelectCinema(data.Records[0]);
              this.getReportData();
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cinema_name;
      this.dropDown.selectedCinemaId = event.cinema_id;
      this.$store.dispatch("selectDropdownCinema", event);
      // Update the URL with the selected cinema_id
      if (this.$router) {
        this.$router.replace({
          path: '/screening-schedule',
          query: { ...this.$route.query, cinema_id: event.cinema_id }
        });
      }
    },
    // onSearch() {
    //   _.debounce(function() {
    //     this.getReportData();
    //   }, 1.5 * 1000);
    // },
    getReportData(isExcel = "N", isPdf = "N") {
      if (isExcel == "N" || isPdf == "N") {
        this.screenRecords = [];
      }
      if (!this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Select Cinema");
      }
      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      }

      let loader = this.$loading.show();
      let payload = {
        cinema_id: this.dropDown.selectedCinemaId,
        cinema_name: this.dropDown.selectedCinemaName || "",
        cinema_address: this.dropDown.selectedCinema.cine_address || "",
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        type: this.typeObj.type_id,
        closeShow: this.openShowOnly == "N",
        isPdf,
      };

      ScheduleService.GetScreeningSchedule(payload)
        .then((response) => {
          const { data } = response;
          loader.hide();
          if (data.status && data.Records.length > 0) {
            this.TotalCount = data.totalCount;
            setTimeout((z) => {
              this.startInterval();
            }, 2000);
            this.screenRecords = data.Records;
            if (isPdf == "Y" && data.pdfPath) {
              window.open(data.pdfPath, "_blank");
            }
            this.calculateGrandTOtal();
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
  },
};
</script>

<style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}

.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  overflow-x: scroll !important;
  border: 1px solid black;
}

.swc-report-table td {
  white-space: nowrap;
}

.swc-report-table th {
  white-space: nowrap !important;
  border: 1px solid black !important;
}

.swc_table_header th {
  border: 1px solid black !important;
}

.no_border {
  border: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/screenScheduling.vue